import { render, staticRenderFns } from "./BeijingUnicom01.vue?vue&type=template&id=1c1bac68&scoped=true"
import script from "./BeijingUnicom01.vue?vue&type=script&lang=js"
export * from "./BeijingUnicom01.vue?vue&type=script&lang=js"
import style0 from "./BeijingUnicom01.vue?vue&type=style&index=0&id=1c1bac68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1bac68",
  null
  
)

export default component.exports